import React from "react";
import Footer from "../Footer";
import Navbar from "../Navbar";

const UserDataDeletionPolicy: React.FC = () => {
  const deletionSections = [
    {
      title: "1. Right to Request User Data Deletion",
      content:
        "Users may request deletion of their personal data at any time. We respect your right to privacy, transparency, and control over your information.",
    },
    {
      title: "2. How to Request User Data Deletion",
      list: [
        `Send an email to ${import.meta.env.VITE_COMPANY_EMAIL}`,
        "Use the subject line: “User Data Deletion Request”",
        "Send the request from your registered mobile number or email address",
      ],
    },
    {
      title: "3. Verification Process",
      content:
        "To ensure data security and prevent unauthorized requests, we verify the identity of the requester before processing any data deletion request.",
    },
    {
      title: "4. User Data That Will Be Deleted or Anonymized",
      list: [
        "User profile details",
        "Registered phone number",
        "Email address",
        "PAN and other personal identification information",
      ],
    },
    {
      title: "5. Legal & Regulatory Data Retention",
      content:
        "Certain user data may be retained where required under applicable laws such as KYC, AML, or other regulatory and compliance obligations.",
    },
    {
      title: "6. Secure Retention & Final Deletion",
      content:
        "Any data required to be retained for legal or regulatory purposes will be securely stored and permanently deleted once the applicable retention period expires.",
    },
    {
      title: "7. Contact Information",
      list: [
        `Email: ${import.meta.env.VITE_COMPANY_EMAIL}`,
      ],
    },
  ];

  return (
    <div className="min-w-screen bg-[var(--background-gradient-middle)]">
      <div className="max-w-[1440px] mx-auto flex flex-col gap-12 px-4 sm:px-6 lg:px-12 py-16">
        <Navbar />

        {/* Header */}
        <div className="text-center mt-12 relative z-10 w-full mb-2 mt-12">
          <h1 className="text-4xl md:text-7xl font-[900] leading-none tracking-tighter mb-4 bg-gradient-to-r from-[var(--primary)] to-[var(--secondary-accent)] text-transparent bg-clip-text">
            User Data Deletion Policy
          </h1>
          <p className="text-[var(--text-gray)] font-bold text-lg md:text-xl max-w-3xl mx-auto leading-relaxed">
            Learn how you can request deletion of your personal data from
            <span className="font-semibold text-[var(--primary)] text-xl">
              {" "}
              {import.meta.env.VITE_COMPANY_NAME}
            </span>.
          </p>
        </div>

        {/* Policy Content */}
        <div className="max-w-4xl w-full mx-auto">
          <div className="bg-white/40 backdrop-blur-3xl rounded-[32px] md:rounded-[40px] border-2 border-white/50 shadow-[20px_20px_40px_rgba(0,0,0,0.04)] p-8 md:p-12 space-y-10">
            {deletionSections.map((section, idx) => (
              <div key={idx} className="space-y-4">
                <h2 className="text-2xl font-[900] text-[var(--text-primary)] tracking-tight mb-2 border-b-2 border-[var(--primary)]/20 pb-2">
                  {section.title}
                </h2>
                {section.content && (
                  <p className="text-[var(--text-gray)] text-base whitespace-pre-line leading-relaxed font-medium">
                    {section.content}
                  </p>
                )}
                {section.list && (
                  <ul className="list-disc list-outside ml-6 space-y-2 text-[var(--text-gray)] text-base font-medium">
                    {section.list.map((li, i) => (
                      <li key={i} className="pl-1">{li}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default UserDataDeletionPolicy;
